import React, { useEffect, useRef, useState } from "react";
import { useDebounce, useLocation, useMeasure, useSetState } from "react-use";
import Configuration from "../../../../../../Config/Config";
import { getCommonStorage } from "../../../../../../Config/gql";
import { Carousel, Empty, Pagination, Skeleton, Spin, Tooltip } from "antd";
import MCC from "../../../../ComponentCommon/MiddleContent";
import Common from "../../../../../../Utils/Common";
import { Link } from "react-router-dom";
import { SpinIcon } from "../../../../ComponentCommon/PageLoading";
import { useHistory } from "react-router-dom";
import { useQuery } from "urql";
import HeaderScene from "../../../../ComponentCommon/HeaderScene";
import { queryAuthors, queryPrivilegeCategories, queryPermissionArticles } from "../../../Blog/maxcoach/PublicBlog/gql";
import { RenderItem } from "../../../Blog/maxcoach/PublicBlog/index";
import Breadcrumb from "../../../../ComponentCommon/maxcoach/Breadcrumb";
import { BookItem, BookItemBox, FileItem, PopularBooks } from "../../../Books/maxcoach/Books/styled";
import { QUERY_ARTICLE, QUERY_CATEGORIES } from "../../../Books/maxcoach/Books/gql";
import { QUERY_MY_COURSES } from "../../../Course/maxcoach/UserCourse/gql";
import { PageTitleSection } from "../../../Course/maxcoach/UserCourse/ecs";
import { AnalyticsItems } from "../../../Course/maxcoach/UserCourse/index";
import { RenderBookItem } from "../../../Books/maxcoach/Books/index";
import LoadingSpinner from "../../../../ComponentCommon/LoadingSpinner";
import "./styles.less";
import PropTypes from "prop-types";
import _ from "lodash";
import { Tree } from "antd";
import { Input } from "antd";
import * as esc from "./esc";
import moment from "moment";
import { QUERY_PRODUCT_CATEGORIES, QUERY_SKIP_PURCHASE_PRODUCTS, QUERY_LEARNING_MATERIALS } from "./gql";
import { useSelector } from "react-redux";
import {
  CourseProgressBar,
  CourseProgressBarValue,
  SideSortSection,
  SideWidgetDescription,
} from "../../../Course/maxcoach/UserCourse/styled";
import { Select } from "antd";
import { ClearAll, CustomInput, NoItems } from "./styled";
import queryString from "query-string";
import { useDiscount } from "./useDiscount";
import {useTranslation} from "react-i18next"
const { Option } = Select;

function MaxcoachProductsPage() {
 
  const {t} = useTranslation()
  
  const history = useHistory();
  const merchant = useSelector((state) => state.Merchant.merchant);
  const location = useLocation();
  const [state, setState] = useSetState({
    courses: [],
    itemPerPage: 24,
    totalItem: 0,
    currentPage: 0,
    categoryIds: [],
    authorIds: [],
    courseTypeIds: [],
    newestProducts: [],
    sortBy: "createdDate",
    filterByCourseTypes: [],
    filterByProviders: [],
    filterByIntructors: [],
    filterByPopular: [],
    minStudents: 0,
    maxStudents: 10000000,
    keyword: "",
    filterByProgresses: [],
    filterByCategories: [],
  });

  
  

//   useEffect(() => {
    
//  QueryGraphQL.getCourse(0, 10)
//   .then((data) => {
//     if (data.courses.items?.length) {
//       setState({
//         courses: data.courses.items,
//         //totalItem: data.courses.totalCount,
//       });
//     }
//   })
//   .finally(() => {
//     setState({ loading: false });
//   });
//   }, []);

  const [fetchCategoriesResult] = useQuery({
    query: QUERY_PRODUCT_CATEGORIES,
    variables: (() => {
      const commonStorage = getCommonStorage();

      return {
        type: 3,
        merchantId: commonStorage.merchantId,
        languageId: commonStorage.languageId,
      };
    })(),
  });

  const [fetchAuthors] = useQuery({
    query: queryAuthors,
    variables: (() => {
      const { merchantId, languageId } = getCommonStorage();

      return { merchantId, languageId };
    })(),
    requestPolicy: "cache-and-network",
  });

  const [fetchProductsResult] = useQuery({
    query: QUERY_SKIP_PURCHASE_PRODUCTS,
    variables: (() => {
      const commonStorage = getCommonStorage();
      let order = "desc";
      let sort = state.sortBy;
      if (sort.includes("|")) {
        const temp = sort.split("|");
        order = temp[0];
        sort = temp[1];
      }
      return {
        type: Configuration.productType.course,
        merchantId: commonStorage.merchantId,
        languageId: commonStorage.languageId,
        offset: state.itemPerPage * state.currentPage,
        limit: state.itemPerPage,
        categoryIds: state.categoryIds.concat(state.filterByCourseTypes),
        authorIds: state.authorIds.concat(state.filterByCourseTypes),
        sort,
        order,
        minStudents: state.minStudents,
        maxStudents: state.maxStudents,
        keyword: state.keyword,
        tokenUser: commonStorage.tokenId,
      };
    })(),
    requestPolicy: "cache-and-network",
  });

  const [fetchLearningMaterialsResult] = useQuery({
    query: QUERY_LEARNING_MATERIALS,
    variables: (() => {
      const commonStorage = getCommonStorage();
      let order = "desc";
      let sort = state.sortBy;
      return {
        languageId: commonStorage.languageId,
        offset: state.itemPerPage * state.currentPage,
        limit: state.itemPerPage,        
        sort,
        order,        
        tokenUser: commonStorage.tokenId,
      };
    })(),
    requestPolicy: "cache-and-network",
  });

  const scrollToList = () => {
    const allCoursesElement = document.getElementById("all-courses");

    if (allCoursesElement) {
      allCoursesElement.scrollIntoView();
    }
  };
  const handlePageChange = (pageIndex, shouldScroll = true) => {
    setState({ currentPage: pageIndex });

    if (shouldScroll) {
      scrollToList();
    }
  };
  const _clearAll = () => {
    setState({
      categoryIds: [],
      filterByCourseTypes: [],
      filterByProviders: [],
      filterByIntructors: [],
      filterByPopular: [],
      keyword: "",
    });
    history.push({
      pathname: "/product",
      search: "",
    });
  };

  useEffect(() => {
    const params = queryString.parse(location.search);

    window.scrollTo(0, 0);
    setState({ keyword: params.q || "" });
  }, [location.search]);
  useEffect(() => {
    window.scrollTo(0, 0);
    handlePageChange(0, false);
  }, [location.pathname]);
  useEffect(() => {
    if (fetchProductsResult.data) {
      const products = fetchProductsResult.data?.skippurchasedproducts?.items || [];

      setState({
        totalItem: fetchProductsResult.data?.skippurchasedproducts?.totalCount || 0,
      });

      if (state.newestProducts.length === 0) {
        const newestProducts = [];

        for (let i = 0; i < Math.min(products.length, 3); i++) {
          newestProducts.push(products[i]);
        }

        setState({ newestProducts });
      }
    }
  }, [fetchProductsResult.data]);
  useEffect(() => {
    if (state.filterByPopular.length) {
      let min = Number.MAX_VALUE;
      let max = Number.MIN_VALUE;
      _.forEach(state.filterByPopular, (v) => {
        const arr = v.split("-").map((v) => +v);

        for (let n of arr) {
          if (n < min) min = n;
          if (n > max) max = n;
        }
      });

      setState({ minStudents: min, maxStudents: max });
    } else {
      setState({ minStudents: 0, maxStudents: 10000000 });
    }
  }, [state.filterByPopular]);

  const isSuccess = !!fetchProductsResult.data;
  const products = fetchProductsResult.data?.skippurchasedproducts?.items || [];
  const learningMaterials = fetchLearningMaterialsResult.data?.courses?.items || [];
  const categories = fetchCategoriesResult.data?.categories?.items || [];
  // const isHome = location.pathname === "/";
  const isHome = true;
  const izziMember = JSON.parse(merchant.izziMember || "{}");
  const showClearAll =
    state.categoryIds.length > 0 ||
    state.filterByIntructors.length > 0 ||
    state.filterByProviders.length > 0 ||
    state.filterByCourseTypes.length > 0 ||
    state.filterByPopular.length > 0;
  const rootCategories = categories.filter((v) => {
    return !v.parentId || v.parentId === "00000000-0000-0000-0000-000000000000";
  });
  const childCategories = (() => {
    const temp = _.cloneDeep(state.categoryIds);
    const ignores = {};

    if (state.categoryIds.length > 0) {
      while (true) {
        let count = 0;

        for (let j = 0; j < categories.length; j++) {
          const v = categories[j];

          if (ignores[v.id]) continue;

          if (temp.includes(v.parentId)) {
            temp.push(v.id);
            ignores[v.id] = true;
            count++;
          }
        }

        if (count === 0) {
          break;
        }
      }
    }

    return categories.filter((v) => {
      if (state.categoryIds.length > 0) {
        return temp.includes(v.parentId);
      }

      return v.parentId && v.parentId !== "00000000-0000-0000-0000-000000000000";
    });
  })();
  const authors = fetchAuthors.data?.users?.items || [];
  const isEmpty = isSuccess && products.length === 0;
  const popularFilterList = [
    // { id: "1-1000", name: "< 1000 students" },
    // { id: "2-4", name: "< 1000 students" },
    { id: "1000-2000", name: "1000 - 2000 students" },
    { id: "2000-4000", name: "2000 - 4000 students" },
    { id: "5000-100000000", name: "> 5000 students" },
  ];
  const merchantFilterList = [merchant];

  if (isEmpty) {
    window.scrollTo(0, 0);
  }


  const [fetchPopularBooks] = useQuery({
    query: QUERY_ARTICLE,
    requestPolicy: "cache-and-network",
    variables: (() => {
      const { languageId, merchantId } = getCommonStorage();

      return {
        type: 5,
        languageId,
        merchantId,
        limit: 5,
        sort: "createdDate",
        order: "desc",
      };
    })(),
  });  

  
  const popularBooks = fetchPopularBooks.data?.articles?.items || [];
  
  const [fetchCategories] = useQuery({
    query: queryPrivilegeCategories,
    variables: (() => {
      const { merchantId, languageId, tokenId } = getCommonStorage();

      return { type: 2, merchantId, languageId, tokenUser: tokenId };
    })(),
    requestPolicy: "cache-and-network",
  });
  const blogCategories = fetchCategories.data?.privilegecategories?.items || [];
  const [fetchPermissionArticles] = useQuery({
    query: queryPermissionArticles,
    variables: (() => {
      const { tokenId, merchantId, languageId } = getCommonStorage();

      return {
        tokenUser: tokenId,
        merchantId,
        languageId,
        categoryIds: blogCategories.map((v) => v.id),
        authorIds: state.authors,
        limit: 10,
        offset: 0,
      };
    })(),
    requestPolicy: "cache-and-network",
    //pause: fetchCategories.fetching,
  });

  const articles = fetchPermissionArticles.data?.articlesmember?.items || [];   

  const [fetchMyCourses] = useQuery({
    query: QUERY_MY_COURSES,
    variables: (() => {
      const { languageId, merchantId, tokenId } = getCommonStorage();

      return {
        offset: state.offset,
        limit: 666,
        languageId,
        merchantId,
        tokenId,
      };
    })(),
    requestPolicy: "cache-and-network",
  });

  useEffect(() => {
    const courses = fetchMyCourses.data?.usercourses?.items || [];
    const categories = (() => {
      const categories = [];

      _.forEach(courses, (course) => {
        _.forEach(course.categories, (category) => {
          let index = _.findIndex(categories, (v) => v.id === category.id);

          if (index === -1) {
            categories.push(category);
          }
        });
      });

      return categories;
    })();

    //setCategories(categories);
  }, [fetchMyCourses.data]);
  const fetching = fetchMyCourses.fetching;

  const courses = (fetchMyCourses.data?.usercourses?.items || []).filter((item) => {
    if (item.percent < 100) {
      item.progress = "in-progress";
    } else {
      item.progress = "completed";
    }

    if (state.filterByProgresses.length > 0) {
      if (!state.filterByProgresses.includes(item.progress)) return false;
    }

    if (state.filterByCategories.length) {
      let index = _.findIndex(item.categories, (v) => state.filterByCategories.includes(v.id));

      if (index === -1) return false;
    }

    return true;
  });

  const allCourses = fetchMyCourses.data?.usercourses?.items || [];
  const totalCount = fetchMyCourses.data?.usercourses?.totalCount || 0;
  const currentCourse = _.find(
    fetchMyCourses.data?.usercourses?.items || [],
    (v) => v.id === localStorage.getItem("currentCourse")
  );
  const studyTime = _.sum(
    allCourses.map((v) => {
      return (v.period * v.percent) / 100;
    })
  );
  const totalCertificates = _.sum(
    allCourses.map((v) => {
      return v.certificate ? 1 : 0;
    })
  );
  const pageTitle = t("My Learning Center");
  const pageDescription = t("Pick up where you left off and review what you’ve learned.");


  return (
    <React.Fragment>
      <div className={"dn"} id={"dongsec"}>
        <div className={"wraper"}>
          <HeaderScene
            image={isHome ? izziMember.ImagePath : undefined}
            //minHeight = {700}
            
            title={isHome ? " " : undefined}
            subTitle={isHome ? (izziMember.Description) || " " : undefined}
            showIntroducing={!isHome}
            logo={
              !isHome && Common.getImageThumbnail(merchant.images, "?mode=crop&width=100&height=64")
            }
          />

          {/* book here */}
         
          <div className="page-title-section section" style={{paddingTop:0}}>
        <div className="page-title">
          <div className="container">
            <PageTitleSection>
              <h1 className="title">{t(pageTitle)}</h1>
              <p>{t(pageDescription)}</p>
            </PageTitleSection>
          </div>
        </div>
        {/* <Breadcrumb items={[{ name: "Home", href: "/" }, { name: "" }]} /> */}
      </div>
          <div className="section section-padding-bottom">
            <div className="container">
            <AnalyticsItems
                  // title={"Statistics"}
                  items={[
                    {
                      label: t("Total Course"),
                      value: totalCount,
                      suffix: "courses",
                      icon: "fa-graduation-cap",
                    },
                    {
                      label: t("Study Hours"),
                      value: parseFloat(parseFloat(studyTime / 60).toFixed(2)),
                      suffix: "hours",
                      background: "green",
                      icon: "fa-clock",
                    },
                    {
                      label: t("Course Certificate"),
                      value: totalCertificates,
                      suffix: "certificates",
                      background: "pink",
                      icon: "fa-file-certificate",
                    },
                    {
                      label: t("Courses Completed"),
                      value: allCourses.filter((v) => parseInt(v.percent) === 100).length,
                      suffix: "completed",
                      background: "blue",
                      icon: "fa-check-circle",
                    },
                  ]}
                />
              <div className="row max-mb-n50">
              <div className="col-lg-12 col-12 order-lg-1 max-mb-50">
              
              {/**/}
              <SideWidget title={t("New Books")}>
                <PopularBooks>
                  <div className="uk-position-relative" tabIndex={-1} uk-slider="autoplay: true">
                    <ul className="uk-slider-items uk-child-width-1-1 uk-child-width-1-3@m uk-child-width-1-2@s uk-grid">
                      {popularBooks.map((item, i) => {
                        const detailUrl = "/book/" + item.id + "/" + Common.rewriteUrl(item.name);
                        const files = item?.files || [];

                        if (files.length === 0) {
                          return null;
                        }
    
                        return (
                          <BookItem key={i}>                    
                            <RenderBookItem
                              item={item}
                              key={i}
                              index={i}
                              onClick={() => {
                                if (files.length === 1) {
                                  const win = window.open(
                                    //"/bookRead?file=" + encodeURIComponent(files[0].path)
                                    "/bookRead?file=" + files[0].path
                                  );
                                  win.focus();
                                } else {
                                  setState({ selectedBook: item });
                                }
                              }}
                            />
                          </BookItem>
                        );
                      })}
                    </ul>
                    <div className="uk-flex uk-flex-center mt-2">
                      <ul className="uk-slider-nav uk-dotnav" />
                    </div>
                  </div>
                </PopularBooks>
              </SideWidget>
              <SideWidget title={t("Learning Materials")}>
                <PopularBooks>
                  <div className="uk-position-relative" tabIndex={-1} uk-slider="autoplay: true">
                    <ul className="uk-slider-items uk-child-width-1-1 uk-child-width-1-3@m uk-child-width-1-2@s uk-grid">
                    {learningMaterials.map((item, i) => {

                        return (
                        <li key={i}>       
                              <div
                            key={i}
                            className="col max-mb-30 animate__animated animate__fadeInUp"
                            onClick={() =>
                              history.push(`/course/${item.id}/${Common.rewriteUrl(item.name)}`)
                            }>
                            <div className="course-2">
                              <div className="thumbnail">
                                <Link to={"/"} className="image" onClick={(e) => e.preventDefault()}>
                                  <span
                                    style={{
                                      display: "inline-block",
                                      minHeight: 250,
                                      height: 250,
                                      width: "100%",
                                      background: "#C3C3C3",
                                    }}>
                                    <MCC className={"img-object-fit-container"}>
                                      <img
                                        className={"img-object-fit"}
                                        style={{ display: "inline-block" }}
                                        src={Common.getImageThumbnail(
                                          item.images,
                                          Configuration.imageFormatCoursesMaxcoach
                                        )}
                                        alt="Course"
                                      />
                                    </MCC>
                                  </span>
                                </Link>
                              </div>
                              <div className="info" style={{ height: "calc(100% - 250px)" }}>
                                <span className="date">
                                {Common.formatDateTime(item.createdDate, "dd/mm/yyyy")}
                                </span>
                                <h3 className="title">
                                  <Tooltip title={item.name.length > 50 ? item.name : undefined}>
                                    <Link to={"/"} onClick={(e) => e.preventDefault()}>
                                      {Common.formatName(item.name, 50)}
                                    </Link>
                                  </Tooltip>
                                </h3>
                                <p>{Common.formatName(item.subDescription, 100)}</p>
                              </div>
                            </div>
                          </div>
                          </li>
                          );                       
                        
                      })}
                    </ul>
                    <div className="uk-flex uk-flex-center mt-2">
                      <ul className="uk-slider-nav uk-dotnav" />
                    </div>
                  </div>
                </PopularBooks>
              </SideWidget>

              <SideWidget title={t("New Blogs")}>
                <PopularBooks>
                  <div className="uk-position-relative" tabIndex={-1} uk-slider="autoplay: true">
                    <ul className="uk-slider-items uk-child-width-1-1 uk-child-width-1-3@m uk-child-width-1-2@s uk-grid">
                    {articles.map((article, i) => {

                        return (
                        <li key={i}>       
                          <RenderItem article={article} key={i} />
                          </li>
                          );                       
                        
                      })}
                    </ul>
                    <div className="uk-flex uk-flex-center mt-2">
                      <ul className="uk-slider-nav uk-dotnav" />
                    </div>
                  </div>
                </PopularBooks>
              </SideWidget>
            </div>
                <div className="col-lg-3 col-12 order-lg-1 max-mb-50">
                  <React.Fragment>
                    <SideWidget title={t("CATEGORIES")} canExpand={true}>
                      <FilterItems
                        items={rootCategories}
                        loading={fetchCategoriesResult.fetching}
                        onChange={(categoryIds) => setState({ categoryIds })}
                        search={true}
                        value={state.categoryIds}
                        placeholder={t("Enter category name")}
                      />
                    </SideWidget>
                    <esc.SideWidgetDivider />
                    <SideWidget title={t("COURSE TYPE")} canExpand={true}>
                      <FilterItems
                        items={childCategories}
                        onChange={(filterByCourseTypes) => setState({ filterByCourseTypes })}
                        value={state.filterByCourseTypes}
                        checkStrictly={false}
                      />
                    </SideWidget>
                    <esc.SideWidgetDivider />
                    {/* <SideWidget title={t("PROVIDER")} canExpand={true}>
                      <FilterItems
                        items={merchantFilterList}
                        onChange={(filterByProviders) => setState({ filterByProviders })}
                        value={state.filterByProviders}
                        search={true}
                        placeholder={t("Find a provider")}
                      />
                    </SideWidget> 
                    <esc.SideWidgetDivider />*/}
                    <SideWidget title={t("INSTRUCTOR")} canExpand={true}>
                      <FilterItems
                        items={authors}
                        loading={fetchAuthors.fetching}
                        onChange={(authorIds) => setState({ authorIds })}
                        value={state.authorIds}
                        search={true}
                        placeholder={t("Enter instructor name")}
                      />
                    </SideWidget>
                    {/*<esc.SideWidgetDivider />
                     <SideWidget title={t("POPULAR")} canExpand={true}>
                      <FilterItems
                        items={popularFilterList}
                        onChange={(filterByPopular) => setState({ filterByPopular })}
                        value={state.filterByPopular}
                        search={false}
                        placeholder={t("Enter instructor name")}
                      />
                    </SideWidget> */}
                    
                    {showClearAll && <ClearAll onClick={_clearAll}>Clear All</ClearAll>}
                  </React.Fragment>
                </div>
                <div className="col-lg-9 col-12 order-lg-1 max-mb-50">
                  <React.Fragment>
                    <div hidden={state.newestProducts.length === 0 || isEmpty}>
                      <CardCarousel
                        title={t("Featured")}
                        items={state.newestProducts}
                        renderItem={(item) => {
                          const src = Common.getImageThumbnail(
                            item.images,
                            Configuration.imageFormatCoursesMaxcoach
                          );
                          const courseUrl = `/product/${item.id}/${Common.rewriteUrl(item.name)}`;

                          return (
                            <esc.HorizontalProductItem onClick={() => history.push(courseUrl)}>
                              <div className={"dx-cell"}>
                                <div className={"dx-content"}>
                                  <h1 className={"dx-title"}>{item.name}</h1>
                                  <p className={"dx-desc"}>
                                    {item.subDescription && (
                                      <span>{Common.formatName(item.subDescription, 160)}</span>
                                    )}
                                    {!item.subDescription && (
                                      <span>
                                        {(() => {
                                          const metaTag = JSON.parse(merchant.metaTag || "{}");

                                          return Common.formatName(metaTag.Description, 160);
                                        })()}
                                      </span>
                                    )}
                                  </p>
                                  <div className={"dx-author"}>
                                    <div className={"dx-avatar"}>
                                      <img
                                        src={getAuthorAvatar(item, merchant, "")}
                                        alt={"Avatar"}
                                      />
                                    </div>
                                    <div className={"dx-name"}>
                                      <p>{getAuthorNames(item, merchant)}</p>
                                      <p>
                                        {(() => {
                                          const metaTag = JSON.parse(merchant.metaTag || "{}");

                                          return metaTag.Title;
                                        })()}
                                      </p>
                                    </div>
                                  </div>
                                  <esc.PreviewCourseInfo className={"dx-rating"}>
                                    {!(item.quantityRating > 0) && <p>No review yet</p>}
                                    {item.quantityRating > 0 && (
                                      <p>
                                        <i className="fas fa-star" />{" "}
                                        <span>{parseFloat(item.averageRating).toFixed(1)}</span> (
                                        {item.quantityRating})
                                      </p>
                                    )}
                                    <p>
                                      <span>
                                        {Number(item.quantityStudent).toLocaleString("vi-VN")}
                                      </span>
                                      {" students"}
                                    </p>
                                  </esc.PreviewCourseInfo>
                                  <div className={"dx-price2"}>
                                    {Number(item.price).toLocaleString("vi-VN")}₫
                                  </div>
                                </div>
                              </div>
                              <div className={"dx-cell"}>
                                <img src={src} alt="Thumbnail" />
                                <esc.CarouselImageInfo>
                                  <div>
                                    <span className={"dx-brand"} hidden={!item.merchantLogo}>
                                      <img
                                        src={Configuration.imageUrl + item.merchantLogo}
                                        alt={"Brand"}
                                      />
                                    </span>
                                  </div>
                                  <div>
                                    <span className={"dx-hours"}>
                                      {formatTimeToLearn(item.periodCourse * 60)}
                                    </span>
                                  </div>
                                </esc.CarouselImageInfo>
                              </div>
                              {/*{index === 0 && <div className={"dx-rank dx-rank-blue"}>Popular</div>}*/}
                              <div className={"dx-rank dx-rank-pink"}>New</div>
                            </esc.HorizontalProductItem>
                          );
                        }}
                      />
                    </div>
                    {isEmpty && (
                      <NoItems>
                        <h3>{t("No results")}</h3>
                        <p>{t("Try adjusting your search by removing filters")}.</p>
                        <button className={"btn btn-primary"} onClick={_clearAll}>
                          {t("Remove all filters")}
                        </button>
                        <hr />
                        <h3>{t("Some courses you might interested")}</h3>
                      </NoItems>
                    )}
                    <SideWidget
                      title={isEmpty ? undefined : t("All Courses")}
                      description={
                        isEmpty ? (
                          <>
                            {t("Provide by")} <span>{merchant.name}</span>
                          </>
                        ) : undefined
                      }
                      sortable={!isEmpty}
                      sort={[
                        {
                          label: t("Newest"),
                          value: "modifiedDate",
                        },
                        {
                          label: t("Highest Price"),
                          value: "desc|price",
                        },
                        {
                          label: t("Lowest Price"),
                          value: "asc|price",
                        },
                        {
                          label: t("Top Student Reviews"),
                          value: "averageRating",
                        },
                      ]}
                      sortValue={state.sortBy}
                      onSortChange={(v) => setState({ sortBy: v })}>
                      <div
                        id={"all-courses"}
                        style={{
                          opacity: 0,
                          position: "relative",
                          top: -165,
                          pointerEvents: "none",
                        }}
                      />
                      <esc.FilterValuesContainer hidden={isEmpty}>
                        {categories.map((category, i) => {
                          if (
                            state.categoryIds
                              .concat(state.filterByCourseTypes)
                              .includes(category.id)
                          ) {
                            return <span key={i}>{category.name}</span>;
                          }
                          return null;
                        })}
                        {authors.map((author, i) => {
                          if (state.authorIds.includes(author.id)) {
                            return <span key={i}>{author.name}</span>;
                          }
                          return null;
                        })}
                        {popularFilterList.map((v, i) => {
                          if (state.filterByPopular.includes(v.id)) {
                            return <span key={i}>{v.name}</span>;
                          }
                          return null;
                        })}
                        {merchantFilterList.map((v, i) => {
                          if (state.filterByProviders.includes(v.id)) {
                            return <span key={i}>{v.name}</span>;
                          }
                          return null;
                        })}
                      </esc.FilterValuesContainer>
                      <div
                        className="section section-padding-bottom"
                        hidden={!fetchProductsResult.fetching}>
                        <div className="container">
                          <div className="row row-cols-lg-3 row-cols-md-2 row-cols-1 max-mb-n30">
                            <div className={"col max-mb-30"}>
                              <div className={"d-skeleton-image"}>
                                <Skeleton active={true} paragraph={{ rows: 0 }} />
                              </div>
                              <Skeleton active={true} />
                            </div>
                            <div className={"col max-mb-30"}>
                              <div className={"d-skeleton-image"}>
                                <Skeleton active={true} paragraph={{ rows: 0 }} />
                              </div>
                              <Skeleton active={true} />
                            </div>
                            <div className={"col max-mb-30"}>
                              <div className={"d-skeleton-image"}>
                                <Skeleton active={true} paragraph={{ rows: 0 }} />
                              </div>
                              <Skeleton active={true} />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="section section-padding-bottom"
                        hidden={fetchProductsResult.fetching}>
                        <div className="container">
                          {/*{isEmpty && (*/}
                          {/*  <div style={{ textAlign: "center", height: "calc(100vh / 2)" }}>*/}
                          {/*    <MCC>*/}
                          {/*      <Empty*/}
                          {/*        image={Empty.PRESENTED_IMAGE_SIMPLE}*/}
                          {/*        description={"No products."}*/}
                          {/*      />*/}
                          {/*    </MCC>*/}
                          {/*  </div>*/}
                          {/*)}*/}
                          <div className="row row-cols-lg-3 row-cols-md-2 row-cols-1 max-mb-n30">
                            {/*Courses*/}
                            {(isEmpty ? state.newestProducts : products).map((item, i) => (
                              <RenderProductItem
                                key={i}
                                item={item}
                                index={i}
                                type={"product"}
                                sortBy={state.sortBy}
                              />
                            ))}
                            {/*  */}
                          </div>
                          <div className="row max-mt-50" hidden={isEmpty}>
                            <div className="col">
                              <RenderPagination
                                currentPage={state.currentPage}
                                totalItem={state.totalItem}
                                itemPerPage={state.itemPerPage}
                                handlePageChange={handlePageChange}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </SideWidget>
                  </React.Fragment>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default MaxcoachProductsPage;

export function SideWidget(props) {
  const [expanded, setExpanded] = useState(props.defaultExpand);
  const {t} = useTranslation()

  const headerClasses = props.sortable
    ? "row row-cols-lg-2 row-cols-md-2 row-cols-1"
    : "row row-cols-1";

  return (
    <div style={{ position: "relative", clear: "both" }}>
      <div className="sidebar-widget-wrapper pr-0" style={{ position: "relative" }} {...props}>
        <div className="sidebar-widget">
          <div className={headerClasses}>
            <div className={"col"}>
              {props.title && (
                <h3
                  onClick={() => {
                    if (props.hideExpandButton) return;
                    setExpanded(!expanded);
                  }}
                  className="sidebar-widget-title"
                  style={{
                    position: "relative",
                    marginBottom: props.canExpand ? 15 : undefined,
                    cursor: props.canExpand ? "pointer" : undefined,
                    marginLeft: props.canExpand ? -15 : 0,
                  }}>
                  <span style={{ fontSize: props.canExpand ? 16 : undefined }}>{props.title}</span>
                  {props.canExpand && !props.hideExpandButton && (
                    <esc.ExpandButton>
                      <MCC>
                        <span className={"dx-btn"}>
                          <i className={expanded ? "fas fa-chevron-up" : "fas fa-chevron-down"} />
                        </span>
                      </MCC>
                    </esc.ExpandButton>
                  )}
                </h3>
              )}
              {props.description && (
                <SideWidgetDescription>{props.description}</SideWidgetDescription>
              )}
            </div>
            {props.sortable && (
              <div className={"col"} style={{ textAlign: "right" }}>
                <SideSortSection>
                  <span className={"dx-label"}>{t("Sort by")}:</span>
                  <Select
                    bordered={false}
                    value={props.sortValue}
                    style={{ minWidth: 200 }}
                    onChange={props.onSortChange}>
                    {_.map(props.sort, (v, i) => {
                      return (
                        <Option key={i} value={v.value}>
                          {v.label}
                        </Option>
                      );
                    })}
                  </Select>
                </SideSortSection>
              </div>
            )}
          </div>
          <div className="sidebar-widget-content" hidden={props.canExpand && !expanded}>
            {props.children}
          </div>
        </div>
      </div>
    </div>
  );
}

SideWidget.propTypes = {
  title: PropTypes.string,
  canExpand: PropTypes.bool,
  defaultExpand: PropTypes.bool,
  sortable: PropTypes.bool,
  sort: PropTypes.array,
  sortValue: PropTypes.any,
  onSortChange: PropTypes.func,
};

SideWidget.defaultProps = {
  defaultExpand: true,
};

export function FilterItems(props) {
  const {t} = useTranslation()
  const [treeItems, setTreeItems] = useState([]);
  const [searchText, setSearchText] = useState("");

  useDebounce(
    () => {
      const items = (props.items || [])
        .map((v) => {
          return {
            key: v.id || v.value,
            title: v.label || v.name,
            ...v,
          };
        })
        .filter((v) => {
          if (searchText.length === 0) return true;

          return v.title.toLowerCase().includes(searchText.toLowerCase());
        });
      const defaultParentId = "00000000-0000-0000-0000-000000000000";

      _.forEach(items, (item, i) => {
        if (item.parentId === defaultParentId) return;

        const index = _.findIndex(items, (v) => v.id === item.parentId);

        if (index === -1) {
          items[i].parentId = defaultParentId;
        }
      });

      setTreeItems(flat2Tree(items));
    },
    275,
    [props.items, searchText]
  );

  return (
    <React.Fragment>
      {props.search && (
        <esc.SearchItemContainer>
          <CustomInput>
            <Input
              placeholder={props.placeholder || t("Find a topic")}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              onFocus={(e) => e.target.select()}
              onClick={(e) => e.target.select()}
              className={!!searchText ? "has-value" : "no-value"}
            />
          </CustomInput>
        </esc.SearchItemContainer>
      )}
      <esc.LoadingItemContainer hidden={!props.loading}>
        <Skeleton active={true} paragraph={{ rows: 1 }} />
      </esc.LoadingItemContainer>
      <esc.FilterItemContainer hidden={props.loading}>
        <Tree
          key={JSON.stringify(treeItems)}
          checkable
          defaultExpandAll={true}
          autoExpandParent={true}
          selectable={false}
          checkedKeys={props.value}
          onCheck={(e) => {
            if (props.checkStrictly) {
              const { checked: checkedKeys } = e;
              props.onChange && props.onChange(_.cloneDeep(checkedKeys));
            } else {
              props.onChange && props.onChange(_.cloneDeep(e));
            }
          }}
          treeData={treeItems}
          checkStrictly={props.checkStrictly}
          filterTreeNode={(node) => {
            if (searchText.length === 0) return false;

            return node.title.toLowerCase().includes(searchText.toLowerCase());
          }}
        />
      </esc.FilterItemContainer>
    </React.Fragment>
  );
}

FilterItems.defaultProps = {
  checkStrictly: true,
};

export function RenderProductItem(props) {
  const {t} = useTranslation()
  const history = useHistory();
  const merchant = useSelector((state) => state.Merchant.merchant);
  const [brandRef, brandInfo] = useMeasure();
  const [brandWidth, setBrandWidth] = useState(0);
  const [hasDiscounts, priceInfo, discountLabel] = useDiscount(props.item);

  useDebounce(
    () => {
      setBrandWidth(brandInfo.width);
    },
    275,
    [brandInfo.width]
  );

  const { item } = props;
  const itemType = props.type;
  const isProduct = itemType === "product";
  const isCourse = itemType === "my-course";
  let courseUrl = `/product/${item.id}/${Common.rewriteUrl(item.name)}`;
  const students = parseInt(item.quantityStudent);
  const showStar = item.quantityRating > 0;
  const rateValue = parseFloat(item.averageRating).toFixed(1);
  const rateCount = item.quantityRating;

  // console.log("item", item);

  if (isCourse) {
    courseUrl = `/user-course-details/${item.id}`;
  }

  if (hasDiscounts) {
    console.log(priceInfo);
  }

  return (
    <esc.ProductItem
      className="col max-mb-30 animate__animated animate__fadeInUp"
      onClick={() => {
        if (props.newTab) {
          const win = window.open(courseUrl);

          win.focus();
        } else {
          history.push(courseUrl);
        }
      }}>
      <div className="course-2">
        <div className="thumbnail">
          <Link to={"/"} className="image" onClick={(e) => e.preventDefault()}>
            <span>
              <MCC className={"img-object-fit-container"}>
                <img
                  className={"img-object-fit"}
                  style={{ display: "inline-block" }}
                  src={Common.getImageThumbnail(
                    item.images,
                    Configuration.imageFormatCoursesMaxcoach
                  )}
                  alt="Course"
                />
                <span className={"dx-hours"}>
                  {formatTimeToLearn((item.periodCourse || item.period) * 60)}
                </span>
                <span
                  className={"dx-brand"}
                  hidden={!item.merchantLogo}
                  style={{
                    width: brandWidth === 0 ? undefined : brandWidth + 12,
                  }}>
                  <img
                    ref={brandRef}
                    src={Configuration.imageUrl + item.merchantLogo}
                    alt={"Brand"}
                  />
                </span>
              </MCC>
            </span>
          </Link>
        </div>
        <div className="info" style={{ height: "calc(100% - 250px)" }}>
          {isProduct && (
            <esc.PreviewCourseInfo>
              {!showStar && <p>{t("No review yet")}</p>}
              {showStar && (
                <p>
                  <i className="fas fa-star" /> <span>{rateValue}</span> ({rateCount})
                </p>
              )}
              <p>
                <span>{Number(students).toLocaleString("vi-VN")}</span> {t("students")}
              </p>
            </esc.PreviewCourseInfo>
          )}
          <h3 className="title">
            <Tooltip title={item.name.length > 50 ? item.name : undefined}>
              <Link to={"/"} onClick={(e) => e.preventDefault()}>
                {Common.formatName(item.name, 50)}
              </Link>
            </Tooltip>
          </h3>
          <p
            className={"dx-author"}
            style={{
              marginBottom: isCourse ? 50 : undefined,
            }}>
            {getAuthorNames(item, merchant)}
          </p>
        </div>
        {isProduct && (
          <div className={"dx-enroll"}>
            <button className={"btn btn-primary"}>{t("Enroll Now")}</button>
          </div>
        )}
        {isProduct && (
          <h3 className="dx-price whitespace-nowrap">
            {!hasDiscounts && <>{Number(item.price).toLocaleString("vi-VN")}₫</>}
            {hasDiscounts && (
              <>
                <span className="inline-block">
                  {Number(priceInfo.price).toLocaleString("vi-VN")}₫
                </span>
                <span className="inline-block ml-2 text-sm line-through opacity-50">
                  {Number(priceInfo.oldPrice).toLocaleString("vi-VN")}₫
                </span>
              </>
            )}
          </h3>
        )}
        {/*{props.index === 0 && <div className={"dx-rank dx-rank-blue"}>Popular</div>}*/}
        {isProduct && ((props.index < 3 && props.sortBy === "createdDate") || !!discountLabel) && (
          <div
            className={"dx-rank" + (discountLabel ? " dx-rank-blue" : " dx-rank-pink")}
            title={!!discountLabel ? discountLabel : "New"}>
            {!!discountLabel ? discountLabel : "New"}
          </div>
        )}
        {isCourse &&
          (() => {
            const timeLeft = (item.period - (item.period * item.percent) / 100) * 60;
            const formattedPeriod = formatTimeToLearn(timeLeft)
              .replace(/m/g, " minutes")
              .replace(/h/g, " hours");

            return (
              <div className={"dx-price"}>
                <CourseProgressBar>
                  <label>
                    {item.percent > 0 && (
                      <>
                        {item.percent >= 100 && <span>{t("Completed")}</span>}
                        {item.percent < 100 && (
                          <>
                            <span>{formattedPeriod}</span> left
                          </>
                        )}
                      </>
                    )}
                    {!(item.percent > 0) && <>{t("Course not started")}</>}
                  </label>
                  <CourseProgressBarValue style={{ width: `${item.percent}%` }} />
                </CourseProgressBar>
              </div>
            );
          })()}
      </div>
    </esc.ProductItem>
  );
}

export function CardCarousel(props) {
  const carouselRef = useRef(null);
  const [state, setState] = useSetState({
    currentSlide: 0,
  });

  const _nextSlide = () => {
    carouselRef && carouselRef.current.next();
  };
  const _prevSlide = () => {
    carouselRef && carouselRef.current.prev();
  };

  useEffect(() => {
    // carouselRef.current.goTo(0);
  }, [props.item]);

  const items = props.items || [];
  const itemsLength = items.length;

  return (
    <esc.SlideSlipRoot>
      <SideWidget title={props.title}>
        <esc.SideSlipContainer>
          <Carousel
            autoplay={true}
            ref={carouselRef}
            afterChange={(currentSlide) => setState({ currentSlide })}>
            {items.map((item, i) => (
              <esc.SideSlipItem key={i}>{props.renderItem(item, i)}</esc.SideSlipItem>
            ))}
          </Carousel>
        </esc.SideSlipContainer>
        {state.currentSlide < itemsLength - 1 && (
          <button className={"dx-next"} onClick={_nextSlide}>
            <MCC>
              <i className="fas fa-chevron-right" />
            </MCC>
          </button>
        )}
        {state.currentSlide > 0 && (
          <button className={"dx-prev"} onClick={_prevSlide}>
            <MCC>
              <i className="fas fa-chevron-left" />
            </MCC>
          </button>
        )}
      </SideWidget>
    </esc.SlideSlipRoot>
  );
}

export function RenderPagination(props) {
  return (
    <esc.PaginationSection>
      <ul className="pagination center" style={{ whiteSpace: "nowrap" }}>
        <Pagination
          total={props.totalItem}
          pageSize={props.itemPerPage}
          showSizeChanger={false}
          responsive={true}
          current={props.currentPage + 1}
          onChange={(pageIndex) => {
            props.handlePageChange && props.handlePageChange(pageIndex - 1);
          }}
          itemRender={(page, type) => {
            if (!["page", "prev", "next"].includes(type)) return null;

            const renderText = (() => {
              if (type === "prev") {
                return <i className="fas fa-chevron-left" />;
              } else if (type === "next") {
                return <i className="fas fa-chevron-right" />;
              }

              return page;
            })();

            return (
              <li>
                <Link
                  to={"/"}
                  onClick={(e) => e.preventDefault()}
                  className={(() => {
                    const isCurrentPage = page - 1 === props.currentPage;

                    if (type === "page" && isCurrentPage) {
                      return "active";
                    } else if (["prev", "next"].includes(type)) {
                      const maxPage = Math.ceil(props.totalItem / props.itemPerPage);
                      const isDisabled = (() => {
                        if (type === "next") {
                          return props.currentPage === maxPage - 1;
                        }

                        return props.currentPage === 0;
                      })();

                      return ["navigation-button ", isDisabled ? "disabled" : ""].join(" ");
                    }

                    return undefined;
                  })()}>
                  {props.currentPage === page - 1 && (
                    <div>
                      {props.loadingFollow && type === "page" ? (
                        <Spin indicator={SpinIcon} />
                      ) : (
                        <span>{renderText}</span>
                      )}
                    </div>
                  )}
                  {props.currentPage !== page - 1 && <span>{renderText}</span>}
                </Link>
              </li>
            );
          }}
        />
      </ul>
    </esc.PaginationSection>
  );
}

RenderPagination.propTypes = {
  handlePageChange: PropTypes.func,
  currentPage: PropTypes.number.isRequired,
  totalItem: PropTypes.number.isRequired,
  itemPerPage: PropTypes.number.isRequired,
};

//////

function flat2Tree(array, parent, tree) {
  const defaultParentId = "00000000-0000-0000-0000-000000000000";

  tree = typeof tree !== "undefined" ? tree : [];
  parent = typeof parent !== "undefined" ? parent : { id: defaultParentId };

  const children = _.filter(array, function (child) {
    return child.parentId === parent.id;
  });

  if (!_.isEmpty(children)) {
    if (parent.id === defaultParentId) {
      tree = children;
    } else {
      parent["children"] = children;
    }

    _.each(children, function (child) {
      flat2Tree(array, child);
    });
  }

  return tree;
}

export function formatTimeToLearn(seconds) {
  seconds = parseFloat(seconds).toFixed(0);

  if (seconds < 60 && seconds > 0) return `${seconds}s`;

  const duration = moment.duration(seconds, "seconds");
  const stringBuilder = [];

  if (duration.hours() > 0) {
    stringBuilder.push(duration.hours() + "h");
  }

  stringBuilder.push(duration.minutes() + "m");

  return stringBuilder.join(" ");
}

export function getAuthorNames(item, merchant) {
  const authors = item.authors || [];
  const authorNames = authors
    .map((v) => [v.lastName, v.firstName].filter((v) => v && v.length > 0).join(" "))
    .filter((v) => v && v.length);

  if (authorNames.length === 0) {
    if (merchant) {
      authorNames.push(merchant.name);
    } else {
      authorNames.push("Anonymous");
    }
  }

  return ["By:", authorNames.join(", ")].join(" ");
}

export function getAuthorAvatar(item, merchant, resizeMode = "?mode=crop&width=33&height=33") {
  return Common.getImageThumbnail(merchant.images, resizeMode);
}
